module.exports = "https://assets.niwcorp.com/_next/static/images/niw-logo-b4403ce66ac2467e81bc19c6381fac63.png";